// ChartOfAccountsService.js
// Handles Chart of Accounts API integration
import axios from 'axios';
import { baseUrl_SPB } from '../../BaseUrl';

// Fetches chart of accounts as a list
export const fetchChartOfAccountsList = (token) => {
  return axios.get(`${baseUrl_SPB}/api/v1/accounting/coa/list`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  });
};

// Fetches chart of accounts as a map
export const fetchChartOfAccountsMap = (token) => {
  return axios.get(`${baseUrl_SPB}/api/v1/accounting/coa`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  });
};
